import axios from 'axios'

export function createAxios(store, router) {

    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    axios.defaults.timeout = 10000;
    
    axios.interceptors.request.use((config) => {
        config.url = store.getters.getApi + config.url
        let token = store.getters.getToken;
        config.headers.Authorization =  `Bearer ${token}`;
    
        return config;
    });
    
    axios.interceptors.response.use(
        res => {
            let data = res.config.data && !(res.config.data instanceof FormData) ? JSON.parse(res.config.data) : {}
    
            let newToken = res.headers['new-token']
    
            if (newToken && `Bearer ${newToken}` != axios.defaults.headers.common.Authorization) {
                axios.defaults.headers.common.Authorization = `Bearer ${newToken}`;
                localStorage.setItem('token', newToken);
                store.commit('setToken', newToken);
            }
    
            if (res.data.message || res.data.info) {
                if(!data.mute) {
                   if(res.data.message) notify.error(res.data.message)
                   if(res.data.info) notify.info(res.data.info)
                }
    
                if(res.data.message) {
                    return Promise.reject(res)
                }
            }
    
    
            return res
        },
        error => {
            let res = error.response
            if (res.config.mute) {
                return Promise.reject('Ошибка отправки запроса')
            } else if (res) {
                let code = +res.status
    
                if(code == 401) {
                    router.push({ path: '/', force: true })
                }
    
                let status = code < 500 && code != 419 && code != 401 ? 'warning' : 'error'
                let title = store.getters.error(code).title
                let text = res.data.message
                
                if(!text) {
                    text = store.getters.error(code).message
                }
                
                notify(text, {
                    title: `[${code}] ${title}`,
                    color: status
                })
                
                // return Promise.reject(error.response)
            } else {
                notify.error('Ошибка отправки запроса')
    
                return Promise.reject('Ошибка отправки запроса')
            }
        }
    )
    
    return axios
}


// WEBPACK FOOTER //
// ./src/plugins/axios.js